import React, { useContext } from "react";
import Context from "../../../../context";
import {
  CustomView,
  CustomModal,
  CustomButton2,
  CustomRadioButtonGroup,
} from "../../../../components";

import "./index.sass";
import values from "../../../../values";
import { IItem } from "../../../../types/common.interface";
import utils from "../../../../utils";
import { useTranslation } from "react-i18next";

const Approve = ({
  role,
}: {
  role: "ADMIN" | "SUPER_AGENT_SCHOOL" | "COMPANY";
}) => {
  const {
    showModal,
    setShowModal,
    isLoading,
    selectedService,
    approveFunction,
  } = React.useContext(Context.ServiceScreen);

  const radioButtonList =
    role === "ADMIN"
      ? values.topMenuItems.APPROVE_ROLE_ADMIN
      : values.topMenuItems.APPROVE_ROLE_COMPANY;
  const [selectedRole, setSelectedRole] = React.useState(radioButtonList[0]);

  const { t } = useTranslation();

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------
  return (
    <section id="school-approve-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "APPROVE"}
      >
        <CustomView.Container className="approve-form-content">
          {(role === "ADMIN" || role === "COMPANY") && (
            <>
              <CustomView.Row className="radio-button-group">
                <CustomRadioButtonGroup
                  menus={radioButtonList}
                  selected={selectedRole}
                  onClick={(event: IItem | null) =>
                    setSelectedRole(event !== null ? event : radioButtonList[0])
                  }
                  canNull={false}
                />
              </CustomView.Row>
              <br />
            </>
          )}
          <CustomView.Row className="form-row">
            <CustomView.Column
              large={3}
              medium={4}
              small={6}
              className="form-colum"
            >
              <CustomButton2
                isLoading={isLoading}
                onClick={() => setShowModal!("NONE")}
                title={t("cancel")}
                type="danger"
              />
            </CustomView.Column>
            <CustomView.Column
              large={3}
              medium={4}
              small={6}
              className="form-colum"
            >
              {(role === "ADMIN" || role === "COMPANY") && (
                <SwitchButtonHandler />
              )}
              {role === "SUPER_AGENT_SCHOOL" && (
                <CustomButton2
                  isLoading={isLoading}
                  onClick={() =>
                    approveFunction!({
                      _id: selectedService?._id,
                      isApprove:
                        !selectedService?.approve?.superAgentApprove
                          ?.isApprroved,
                    })
                  }
                  title={
                    selectedService?.approve?.superAgentApprove?.isApprroved ===
                    true
                      ? t("disApprove")
                      : t("approve")
                  }
                  type={
                    selectedService?.approve?.superAgentApprove?.isApprroved ===
                    true
                      ? "warning"
                      : "primary"
                  }
                />
              )}
              {/* {role === "COMPANY" && (
                <CustomButton2
                  isLoading={isLoading}
                  onClick={() => {
                    if (
                      (!selectedService.expire || !selectedService.price) &&
                      !selectedService?.approve?.companyApprove?.isApprroved
                    ) {
                      if (!selectedService.expire) {
                        utils.errorHandler(3500);
                      }
                      if (!selectedService.price) {
                        utils.errorHandler(3501);
                      }
                    } else {
                      approveFunction!({
                        _id: selectedService?._id,
                        isApprove:
                          !selectedService?.approve?.companyApprove
                            ?.isApprroved,
                      });
                    }
                  }}
                  title={
                    selectedService?.approve?.companyApprove?.isApprroved ===
                    true
                      ? "مسدود سازی"
                      : "تایید و رفع مسدودی"
                  }
                  type={
                    selectedService?.approve?.companyApprove?.isApprroved ===
                    true
                      ? "warning"
                      : "primary"
                  }
                />
              )} */}
            </CustomView.Column>
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );

  function SwitchButtonHandler() {
    switch (selectedRole.value) {
      case "SUPER_AGENT_SCHOOL":
        return (
          <CustomButton2
            isLoading={isLoading}
            onClick={() =>
              approveFunction!({
                _id: selectedService?._id,
                isApprove:
                  !selectedService?.approve?.superAgentApprove?.isApprroved,
                approveType: selectedRole.value,
              })
            }
            title={
              selectedService?.approve?.superAgentApprove?.isApprroved === true
                ? t("disApprove")
                : t("approve")
            }
            type={
              selectedService?.approve?.superAgentApprove?.isApprroved === true
                ? "warning"
                : "primary"
            }
          />
        );
      case "COMPANY":
        return (
          <CustomButton2
            isLoading={isLoading}
            onClick={() =>
              approveFunction!({
                _id: selectedService?._id,
                isApprove:
                  !selectedService?.approve?.companyApprove?.isApprroved,
                approveType: selectedRole.value,
              })
            }
            title={
              selectedService?.approve?.companyApprove?.isApprroved === true
                ? t("disApprove")
                : t("approve")
            }
            type={
              selectedService?.approve?.companyApprove?.isApprroved === true
                ? "warning"
                : "primary"
            }
          />
        );
      case "PASSENGER":
        return (
          <CustomButton2
            isLoading={isLoading}
            onClick={() =>
              approveFunction!({
                _id: selectedService?._id,
                isApprove:
                  !selectedService?.approve?.parrentApprove?.isApprroved,
                approveType: selectedRole.value,
              })
            }
            title={
              selectedService?.approve?.parrentApprove?.isApprroved === true
                ? t("disApprove")
                : t("approve")
            }
            type={
              selectedService?.approve?.parrentApprove?.isApprroved === true
                ? "warning"
                : "primary"
            }
          />
        );
      default:
        return null;
    }
  }
};

export default Approve;
